import styled from "styled-components";
import { NoAccountsFilled } from "@assets";

export const RootContainer = styled.div`
	padding: 16px;

	@media screen and (max-width: 350px) {
		padding: 16px 8px;
	}
`;

export const Label = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #000;
  text-align: center;
  `;

export const ItemBox = styled.div`
	padding: 16px;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 12px;
	border-radius: 8px;
	border: 1px solid #999;
	background: #FFF;
	box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.10);
	cursor: pointer;
	margin-bottom: 8px;
`;

export const InfoBox = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: start;
	gap: 4px;
`;

export const ButtonWrapper = styled.div`
	margin: 24px 0 0 0;
	width: 100%;
	text-align: center;
	display: flex;
	justify-content: center;

	.ant-btn-primary {
		width: 100% !important;
		height: 56px;
		padding-inline: 24px;
		display: flex;
		gap: 6px;
		justify-content: center;
		align-items: center;

		span {
			font-size: 16px;
			color: #fff;
			font-weight: 700;
		}
	}

	.ant-btn-icon svg {
		font-size: 20px;
		margin: 0 !important;
	}
`;

export const SpinWrapper = styled.div`
	height: calc(100vh - 70px);
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const Image = styled.img.attrs({
	alt: "img",
})`
	width: 60px;
	border-radius: ${(props) => (props.radius === "none" ? "none" : "8px")};
	object-fit: contain;

	@media screen and (max-width: 378px) {
		width: 46px;
	}
`;

export const Title = styled.div`
padding: 4px 12px;
margin-bottom: 16px;
border-radius: 8px;
background-color: #F8EEFF;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 1.5;
	color: #49028E;
`;

export const NumberText = styled.div`
	font-size: 14px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	color: #FEBF15;

	@media screen and (max-width: 378px) {
		font-size: 13px;
	}
`;

export const Text = styled.div`
	font-size: 14px;
	font-style: normal;
	font-weight: 700;
	line-height: 1.5;
	color: #1C1C1C;
	word-break: break-all;
`;

export const EmptyBox = styled.div`
	margin-top: 16px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 4px;
`;

export const EmptyIcon = styled(NoAccountsFilled)`
margin-bottom: 16px;
`;

export const EmptyTitle = styled.div`
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 1.5;
	color: #979797;
	margin-bottom: 8px;
	text-align: center;
`;

export const EmptyText = styled.div`
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 1.5;
	color: #5C5C5C;
	text-align: center;
`;
